import { linkedinIcon } from "./icons/linkedin.js";
import { githubIcon } from "./icons/github.js";
import { xTwitterIcon } from "./icons/x-twitter.js";
import { instagramIcon } from "./icons/instagram.js";
import { facebookIcon } from "./icons/facebook.js";
import { youtubeIcon } from "./icons/youtube.js";
import { tiktokIcon } from "./icons/tiktok.js";
import { xingIcon } from "./icons/xing.js";
import { whatsappIcon } from "./icons/whatsapp.js";
import { telegramIcon } from "./icons/telegram.js";
import { stackoverflowIcon } from "./icons/stackoverflow.js";
import { dribbbleIcon } from "./icons/dribbble.js";
import { behanceIcon } from "./icons/behance.js";
import { twitchIcon } from "./icons/twitch.js";
import { soundcloudIcon } from "./icons/soundcloud.js";
import { mixcloudIcon } from "./icons/mixcloud.js";
import { spotifyIcon } from "./icons/spotify.js";
import { appleMusicIcon } from "./icons/apple-music.js";
import { deezerIcon } from "./icons/deezer.js";
import { bandcampIcon } from "./icons/bandcamp.js";
import { beatportIcon } from "./icons/beatport.js";
import { discogsIcon } from "./icons/discogs.js";
import { pinterestIcon } from "./icons/pinterest.js";
import { threadsIcon } from "./icons/threads.js";
import { blueskyIcon } from "./icons/bluesky.js";
import { snapchatIcon } from "./icons/snapchat.js";
import { discordIcon } from "./icons/discord.js";
import { redditIcon } from "./icons/reddit.js";
import { vimeoIcon } from "./icons/vimeo.js";
import { mastodonIcon } from "./icons/mastodon.js";
import { mediumIcon } from "./icons/medium.js";
import { patreonIcon } from "./icons/patreon.js";
/**
 * Dynamic lookup map — use this when the icon name comes from config/data
 * at runtime (e.g. in `pd-socialmedia` or `_getAppFooterLinks()`).
 *
 * **Achtung:** Importiert alle Icons. Für optimales Tree-Shaking
 * stattdessen die Named Exports direkt importieren:
 *
 * ```typescript
 * // Tree-shakeable (empfohlen für Apps mit wenigen Icons)
 * import { linkedinIcon, githubIcon } from "@progressive-development/pd-icon-brands";
 *
 * // Dynamischer Lookup (wenn Icon-Name aus Config kommt)
 * import { brandIconMap } from "@progressive-development/pd-icon-brands";
 * const icon = brandIconMap.get("linkedin");
 * ```
 */
export const brandIconMap = new Map([
    ["linkedin", linkedinIcon],
    ["github", githubIcon],
    ["x-twitter", xTwitterIcon],
    ["twitter", xTwitterIcon], // Alias
    ["x", xTwitterIcon], // Alias (pd-socialmedia provider id)
    ["instagram", instagramIcon],
    ["facebook", facebookIcon],
    ["youtube", youtubeIcon],
    ["tiktok", tiktokIcon],
    ["xing", xingIcon],
    ["whatsapp", whatsappIcon],
    ["telegram", telegramIcon],
    ["stackoverflow", stackoverflowIcon],
    ["dribbble", dribbbleIcon],
    ["behance", behanceIcon],
    ["twitch", twitchIcon],
    ["soundcloud", soundcloudIcon],
    ["mixcloud", mixcloudIcon],
    ["spotify", spotifyIcon],
    ["applemusic", appleMusicIcon],
    ["apple-music", appleMusicIcon], // Alias
    ["deezer", deezerIcon],
    ["bandcamp", bandcampIcon],
    ["beatport", beatportIcon],
    ["discogs", discogsIcon],
    ["pinterest", pinterestIcon],
    ["threads", threadsIcon],
    ["bluesky", blueskyIcon],
    ["snapchat", snapchatIcon],
    ["discord", discordIcon],
    ["reddit", redditIcon],
    ["vimeo", vimeoIcon],
    ["mastodon", mastodonIcon],
    ["medium", mediumIcon],
    ["patreon", patreonIcon],
]);
//# sourceMappingURL=brand-icon-map.js.map